import { render, staticRenderFns } from "./GradeDetail.vue?vue&type=template&id=a03ac566"
import script from "./GradeDetail.vue?vue&type=script&lang=js"
export * from "./GradeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports